var _linearGradient, _linearGradient2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderFulfillment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 600 591.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr-order-fulfillment--lg-1",
    x1: -19.9923,
    x2: 628.6926,
    y1: 263.9473,
    y2: 511.3837,
    gradientTransform: "translate(0 -36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1225,
    stopColor: "#4b17ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9787,
    stopColor: "#098aed"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr-order-fulfillment--lg-2",
    x1: 26.7936,
    x2: 675.4783,
    y1: 141.292,
    y2: 388.7285,
    gradientTransform: "translate(0 -36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1225,
    stopColor: "#4b17ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9787,
    stopColor: "#098aed"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41d3bd",
    d: "M435.7 56.4L72.8 152.6c-12.1 3.2-21.6 12.7-24.8 24.8L3 345.3c-3.2 12.1.2 25 9.1 33.8l123 123c8.8 8.8 21.7 12.3 33.7 9.1L531.7 415c12.1-3.2 21.6-12.7 24.8-24.8l39.8-148.4c6.5-24.2-.4-49.9-18.1-67.6L469.4 65.5c-8.8-8.8-21.6-12.3-33.7-9.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.6 298.9l-56.1 209.3c-2.5 9.4 6.1 18 15.5 15.6l124.3-32.3c13.5-3.5 24.1-14 27.7-27.5l58.4-217.8c7.2-26.8-.5-55.4-20.1-75.1L417.5 11.4c-9.8-9.7-23.9-13.6-37.3-10.1L256 33.6c-9.5 2.5-12.7 14.3-5.8 21.3l152.9 152.9c23.9 23.8 33.2 58.6 24.5 91.1z",
    fill: "#098aed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.1 361.4L137 570.7c-2.5 9.4 6.1 18.1 15.5 15.6L292 550c13.5-3.5 24.1-14 27.7-27.5l58.4-217.8c7.2-26.8-.5-55.4-20.1-75.1L198.3 69.8c-9.8-9.8-23.9-13.6-37.3-10.1L21.5 96.1c-9.5 2.5-12.7 14.3-5.8 21.3l152.9 152.9c23.9 23.8 33.2 58.6 24.5 91.1z",
    fill: "#098aed"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hr-order-fulfillment--lg-1)",
    d: "M378.1 304.6c7.2-26.8-.5-55.4-20.1-75.1L237.5 109 75 152.1c-6 1.6-11.5 4.6-15.9 8.6l109.6 109.6c23.8 23.8 33.2 58.6 24.4 91.2L153 511.1c5.8 1.2 12 1.1 17.9-.5l163.6-43.4 43.6-162.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hr-order-fulfillment--lg-2)",
    d: "M575 171.1l-104-104c-9.8-9.8-24.1-13.6-37.4-10.1L290.3 95l112.8 112.8c23.8 23.8 33.2 58.6 24.4 91.2l-41.4 154.6 143.4-38c13.5-3.6 24-14.1 27.6-27.5l38-141.9c7.2-26.9-.5-55.5-20.1-75.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderFulfillment);
export default __webpack_public_path__ + "static/media/order-fulfillment.f0c0a5a1.svg";
export { ForwardRef as ReactComponent };